module.exports = __webpack_public_path__ + "img/百事合意_四方連續_彩稿.e6aaa9e6.png";